import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=b4c96618"
import script from "./contact-form.vue?vue&type=script&lang=js"
export * from "./contact-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports